import { props, createAction } from '@ngrx/store';

import { Batch } from '../../models/registration.model';

export const addBatch = createAction('[Batch] Add batch', props<{ batch: Batch }>());
export const cancelBatch = createAction('[Batch] Cancel batch');
export const resetBatches = createAction('[Batch] Reset batches');
export const updateBatch = createAction('[Batch] Update batch', props<{ batch: Batch }>());
